// extracted by mini-css-extract-plugin
module.exports = {"messager":"messager_messager__6YNWj","login":"messager_login__2Z-M7"};